<template>
  <card class="wrapper" v-if="billPeriodNum > 0">
    <AdminTitle title="账期" size="20px"/>
    <card class="wrapper special-card">
      <div class="item">
        <el-checkbox-group v-model="periodList" @change="changeSelect">
          <el-checkbox v-for="item in billPeriodNum" :key="item" :label="item">第{{ item }}期（￥：{{ eachRentPrice }}）</el-checkbox>
        </el-checkbox-group>
      </div>
    </card>
  </card>
</template>

<script>

export default {
  name: 'PeriodInfo',
  props: ['billPeriodNum', 'eachRentPrice', ],
  data() {
    return {
      periodList: []
    }
  },
  computed: {},
  watch: {
  },
  mounted() {},
  methods: {
    changeSelect() {
      this.$store.commit('UPDATE_PERIOD', this.periodList)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  border-color: transparent;
  margin-top: 20px;
  border-radius: 16px;
  color: #222222;
  .el-checkbox__input + span.el-checkbox__label {
    color: #222222;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #222;
    background-color: #fff
  }
  .el-checkbox__input.is-checked .el-checkbox__inner::after {
    border-color: #222;
  }
  .el-checkbox__input .el-checkbox__inner {
    border-color: #222;
  }
  .first-price {
    font-weight: 600;
  }
  .col2 {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .el-checkbox {
      min-width: 250px;
    }
  }
  .el-button {
    border-radius: 15px;
  }
}
.tip {
  display: inline-block;
  color: #fff;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 20px;
  background: #bd3124;
  position: absolute;
  left: 60px;
  top: 2px;
  font-weight: 550;
  .el-icon-warning {
    color: #fff;
    margin-right: 5px;
  }
}
.special-card {
  background: #f7f8fa;
  line-height: 35px;
  color: #222222;
}
</style>
